(function () {
  if (window.__nestFooterAlignmentTest) return;
  window.__nestFooterAlignmentTest = true;

  function cleanText(value) {
    return (value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function applyFooterAlignmentTest() {
    var headings = Array.prototype.slice.call(document.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    var heading = headings.find(function (item) {
      return /Sign Up For News & Perks/i.test(cleanText(item.textContent));
    });

    if (!heading) return;

    var target = heading.closest('.footer-part, .site-footer__item, .grid__item') || heading.parentElement;
    if (!target) return;

    target.style.setProperty('position', 'relative', 'important');
    target.style.setProperty('top', '-5px', 'important');
    target.style.setProperty('margin-bottom', '-5px', 'important');
    target.style.setProperty('z-index', '1', 'important');
    target.setAttribute('data-nest-footer-alignment-test', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFooterAlignmentTest, { once: true });
  } else {
    applyFooterAlignmentTest();
  }

  window.addEventListener('load', applyFooterAlignmentTest, { once: true });
  [100, 350, 800, 1500, 3000].forEach(function (delay) {
    window.setTimeout(applyFooterAlignmentTest, delay);
  });
})();

(function () {
  var previousScript = 'custom-header-scroll-pre-final-safe-a11y-backup-20260619.js';

  function assetUrl(filename) {
    var script = document.currentScript;
    if (script && script.src) {
      try {
        return new URL(filename, script.src).toString();
      } catch (error) {}
    }
    return filename;
  }

  function loadScript(src) {
    var script = document.createElement('script');
    script.src = src;
    script.async = false;
    (document.head || document.documentElement).appendChild(script);
  }

  function cleanText(value) {
    return (value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function setAttr(element, name, value) {
    if (element && element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function removeLandmarkAttrs(element) {
    if (!element) return;
    element.removeAttribute('role');
    element.removeAttribute('aria-label');
    element.removeAttribute('aria-labelledby');
    element.removeAttribute('aria-describedby');
    element.removeAttribute('tabindex');
  }

  function replaceElementTag(element, tagName) {
    if (!element || !element.parentNode || element.tagName.toLowerCase() === tagName) return element;
    var replacement = document.createElement(tagName);
    Array.prototype.slice.call(element.attributes).forEach(function (attribute) {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    while (element.firstChild) replacement.appendChild(element.firstChild);
    element.parentNode.replaceChild(replacement, element);
    return replacement;
  }

  function labelForRegion(element, fallback) {
    var heading = element && element.querySelector && element.querySelector('h1,h2,h3,h4,h5,h6');
    return cleanText(heading && heading.textContent) || fallback;
  }

  function ensureRegion(element, label) {
    if (!element) return;
    setAttr(element, 'role', 'region');
    if (!element.getAttribute('aria-label') && !element.getAttribute('aria-labelledby')) {
      setAttr(element, 'aria-label', label);
    }
  }

  function showroomStickyLabel() {
    var stickyName = document.querySelector('.store-fixed__name > div:first-child');
    var pageHeading = document.querySelector('main h1, [role="main"] h1, h1');
    return cleanText(stickyName && stickyName.textContent) || cleanText(pageHeading && pageHeading.textContent) || 'Showroom';
  }

  function normalizeHeaderLandmarks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var headerSection = document.getElementById('shopify-section-header');
    var siteHeader = document.querySelector('header.site-header');

    if (headerSection) {
      setAttr(headerSection, 'role', 'banner');
      setAttr(headerSection, 'aria-label', 'Site header');
      headerSection.removeAttribute('aria-labelledby');
      headerSection.removeAttribute('aria-describedby');
      headerSection.removeAttribute('tabindex');
    }

    Array.prototype.forEach.call(scope.querySelectorAll('.sticky-header-content, .sticky-header'), removeLandmarkAttrs);

    if (siteHeader) {
      setAttr(siteHeader, 'role', 'presentation');
      siteHeader.removeAttribute('aria-label');
      siteHeader.removeAttribute('aria-labelledby');
      siteHeader.removeAttribute('aria-describedby');
      siteHeader.removeAttribute('tabindex');
    }
  }

  function stripIconContainerLandmarks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var containers = [];

    if (scope.matches && scope.matches('.icon-container')) containers.push(scope);
    if (scope.querySelectorAll) {
      containers = containers.concat(Array.prototype.slice.call(scope.querySelectorAll('.icon-container')));
    }

    containers.forEach(function (container) {
      if (container.getAttribute('role') === 'region') container.removeAttribute('role');
      container.removeAttribute('aria-label');
      container.removeAttribute('aria-labelledby');
      container.removeAttribute('aria-describedby');
      container.removeAttribute('tabindex');
    });
  }

  function remediateLandmarkContent(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var stickySections = [];

    if (scope.matches && scope.matches('.store-fixed__content')) stickySections.push(scope);
    if (scope.querySelectorAll) {
      stickySections = stickySections.concat(Array.prototype.slice.call(scope.querySelectorAll('.store-fixed__content')));
    }

    stickySections.forEach(function (section) {
      if (section.closest('main, [role="main"], [role="banner"], [role="contentinfo"]')) return;
      ensureRegion(section, showroomStickyLabel() + ' quick showroom contact');
    });

    Array.prototype.forEach.call(scope.querySelectorAll('#slickSlide0'), function (slide) {
      ensureRegion(slide, 'Customer review');
    });

    Array.prototype.forEach.call(scope.querySelectorAll('#shopify-section-compact-quotes-with-video-h2'), function (section) {
      ensureRegion(section, 'Customer reviews');
    });

    Array.prototype.forEach.call(scope.querySelectorAll('.icons-container-title'), function (title) {
      var container = title.closest('.icons-container, .icon-container-wrapper, .large-icons, section, .shopify-section') || title.parentElement;
      ensureRegion(container, cleanText(title.textContent) || 'Product highlights');
    });

    Array.prototype.forEach.call(scope.querySelectorAll('.product-badges-medium'), function (badges) {
      ensureRegion(badges, 'Product awards and certifications');
    });
  }

  function remediateHeadingOrder(root) {
    var scope = root && root.querySelectorAll ? root : document;

    Array.prototype.forEach.call(scope.querySelectorAll('#s-8d895279-2541-4b25-b352-041cc31886b7 > .shogun-heading-component > h3'), function (heading) {
      if (/over-stuffed/i.test(cleanText(heading.textContent))) {
        var paragraph = replaceElementTag(heading, 'p');
        paragraph.removeAttribute('role');
        paragraph.removeAttribute('aria-level');
      }
    });

    Array.prototype.forEach.call(scope.querySelectorAll('#s-938d3108-7474-45c9-bf67-7c26fa8c7378 > .shogun-heading-component > h5, #s-d84d528c-4363-42d1-a4a7-f3551c08ef89 > .shogun-heading-component > h6'), function (heading) {
      var h3 = replaceElementTag(heading, 'h3');
      h3.removeAttribute('role');
      h3.removeAttribute('aria-level');
    });

    Array.prototype.forEach.call(scope.querySelectorAll('h6'), function (heading) {
      if (/love where you sleep; on your nest/i.test(cleanText(heading.textContent))) {
        var paragraph = replaceElementTag(heading, 'p');
        paragraph.removeAttribute('role');
        paragraph.removeAttribute('aria-level');
      }
    });

    Array.prototype.forEach.call(scope.querySelectorAll('#s-7dbedf8f-7f82-4cf3-9929-95b12caded15 .shogun-accordion-title'), function (heading) {
      if (/How do I initiate a comfort exchange/i.test(cleanText(heading.textContent))) {
        var h3 = replaceElementTag(heading, 'h3');
        h3.className = heading.className;
        h3.removeAttribute('role');
        h3.removeAttribute('aria-level');
      }
    });
  }

  function remediateNestedSizeSelector(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('.select:nth-child(4) > .styledSelect[aria-haspopup="listbox"][role="button"]'), function (trigger) {
      var wrapper = trigger.parentElement;
      var nativeSelect = wrapper && wrapper.querySelector && wrapper.querySelector('select');

      Array.prototype.forEach.call(trigger.querySelectorAll('a[href], button, input, select, textarea, [role="button"], [role="link"], [tabindex]:not([tabindex="-1"])'), function (nested) {
        nested.setAttribute('tabindex', '-1');
        nested.setAttribute('aria-hidden', 'true');
        nested.removeAttribute('role');
        nested.removeAttribute('aria-haspopup');
        nested.removeAttribute('aria-expanded');
        if (nested.tagName && nested.tagName.toLowerCase() === 'a') nested.removeAttribute('href');
      });

      if (nativeSelect) {
        nativeSelect.removeAttribute('aria-hidden');
        nativeSelect.removeAttribute('disabled');
        nativeSelect.removeAttribute('tabindex');
        if (!nativeSelect.getAttribute('aria-label') && !nativeSelect.getAttribute('aria-labelledby')) {
          nativeSelect.setAttribute('aria-label', 'Select product size');
        }
        trigger.removeAttribute('role');
        trigger.removeAttribute('tabindex');
        trigger.removeAttribute('aria-haspopup');
        trigger.removeAttribute('aria-expanded');
        trigger.setAttribute('aria-hidden', 'true');
      } else {
        trigger.setAttribute('aria-label', 'Select product size');
      }
    });
  }

  function finalSafeRemediation(root) {
    remediateLandmarkContent(root);
    remediateHeadingOrder(root);
    remediateNestedSizeSelector(root);
    normalizeHeaderLandmarks(root);
    stripIconContainerLandmarks(root);
  }

  function queueRemediation() {
    window.setTimeout(function () {
      finalSafeRemediation(document);
    }, 30);
  }

  loadScript(assetUrl(previousScript));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueRemediation, { once: true });
  } else {
    queueRemediation();
  }

  window.addEventListener('load', queueRemediation, { once: true });
  [100, 350, 800, 1500, 3000, 6000, 9000, 12000, 15000].forEach(function (delay) {
    window.setTimeout(queueRemediation, delay);
  });

  if (window.MutationObserver && document.documentElement) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          finalSafeRemediation(mutation.target);
          return;
        }

        if (!mutation.addedNodes || !mutation.addedNodes.length) return;
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node && node.nodeType === 1) finalSafeRemediation(node);
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'aria-label', 'aria-labelledby', 'aria-describedby', 'tabindex']
    });
  }
})();